module.exports = __webpack_public_path__ + "assets/images/UNFIT1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/UNFIT1.png
// module id = 1438
// module chunks = 1